import { Outlet } from 'react-router-dom';
import Nav from '../common/Nav/Nav';
import MainLayoutWrapper from './MainLayoutWrapper/MainLayoutWrapper';
import { NavProvider } from '../../context/NavContext';
import { TourProvider } from '@reactour/tour';
import ConfirmationModalContextProvider from '../../context/ConfirmModalContext';
import TopBar from '../TopBar/TopBar';
import Stack from '@mui/material/Stack';

const MainLayout = () => {
  return (
    <TourProvider
      disableInteraction={true}
      scrollSmooth={true}
      steps={[]}
      styles={{
        popover: (base) => ({
          ...base,
          "--reactour-accent": 'linear-gradient(to right, #931216, #E20B23, #FF8230)',
          borderRadius: 10
        })
      }}>
      <NavProvider>
        <ConfirmationModalContextProvider>
          {/* https://www.npmjs.com/package/@reactour/tour */}
          <Stack direction="row">
            <Nav />
            <Stack direction="column" width="100%">
              <TopBar />
              <MainLayoutWrapper>
                <Outlet />
              </MainLayoutWrapper>
            </Stack>
          </Stack>
        </ConfirmationModalContextProvider>
      </NavProvider>
    </TourProvider>
  );
};

export default MainLayout;
